<template>
  <div class="wrapper" :class="{ active: toggleMenu }">
    <div class="sidebar">
      <ul>
        <li v-for="(item, index) in pages" :key="index">
          <a
            href="#"
            :class="{ active: index === selectedPage }"
            @click.prevent="selectedPage = index"
          >
            <span class="item">{{ item }}</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="section">
      <div class="top_navbar">
        <div>
          <img
            class="menu-btn btn"
            alt="options"
            src="./../assets/menu.png"
            @click="toggleMenu = !toggleMenu"
          />
        </div>

        <div class="track-box" @mouseover="changePosition()">
          <div class="catch-me">catchMeTexts[0]</div>
          <div class="user-box" @click="stopAnimation()">
            <img :src="userImage" class="profile-image" alt="Profile" />
            <div class="title">
              <span class="username">{{ profile.given_name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div id="page">
        <order-page
          v-if="selectedPage === 'ORDER'"
          @change-page="
            (page) => {
              selectedPage = page;
            }
          "
        />
        <order-history v-else-if="selectedPage === 'ORDER_HISTORY'" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import OrderPage from "./OrderPage.vue";
import OrderHistory from "./OrderHistory.vue";

type PageKey = "ORDER" | "ORDER_HISTORY";

export default defineComponent({
  name: "InternalLayout",
  components: {
    OrderPage,
    OrderHistory,
  },
  data() {
    return {
      toggleMenu: true,
      userImage: localStorage.user_image,
      profile: JSON.parse(localStorage.profile),
      selectedPage: "ORDER" as PageKey,
      pages: {
        ORDER: "Order",
        ORDER_HISTORY: "History",
      },
      animationTimeout: null as number | null,
      catchMeTexts: [
        "Catch me!",
        "Please, catch me!",
        "Click me, please!",
        "Come on!",
        "Don't give up!",
      ],
    };
  },
  methods: {
    changePosition() {
      const userBox = document.querySelector(
        ".user-box"
      ) as HTMLDivElement | null;
      const catchMe = document.querySelector(
        ".catch-me"
      ) as HTMLDivElement | null;
      const target = document.querySelector(
        ".track-box"
      ) as HTMLDivElement | null;
      if (!userBox || !catchMe || !target) {
        return;
      }

      userBox.classList.add("disco");
      catchMe.classList.remove("show");

      const x = (5 + Math.random() * 90).toFixed(0);
      const y = (5 + Math.random() * 80).toFixed(0);
      const r = (Math.random() * 360).toFixed(0);

      target.setAttribute(
        "style",
        `right: ${x}vw; top: ${y}vh; rotate: ${r}deg;`
      );

      clearInterval(this.animationTimeout ?? undefined);
      this.animationTimeout = window.setInterval(() => {
        catchMe.classList.add("show");
        const randomIndex = Math.floor(
          Math.random() * this.catchMeTexts.length
        );
        catchMe.innerHTML = this.catchMeTexts[randomIndex];

        const nextX = (5 + Math.random() * 90).toFixed(0);
        const nextY = (5 + Math.random() * 80).toFixed(0);
        const nextR = (Math.random() * 360).toFixed(0);
        target.setAttribute(
          "style",
          `right: ${nextX}vw; top: ${nextY}vh; rotate: ${nextR}deg;`
        );
      }, 5000);
    },
    stopAnimation() {
      clearInterval(this.animationTimeout ?? undefined);

      const target = document.querySelector(
        ".track-box"
      ) as HTMLDivElement | null;
      const userBox = document.querySelector(
        ".user-box"
      ) as HTMLDivElement | null;
      const catchMe = document.querySelector(
        ".catch-me"
      ) as HTMLDivElement | null;

      target?.removeAttribute("style");
      userBox?.classList.remove("disco");
      catchMe?.classList.remove("show");
    },
  },
});
</script>
